import React from "react";
import "./UserGuidePopup.css";

const UserGuidePopup = ({ isOpen, onClose, pdfUrl }) => {
  if (!isOpen) return null;

  return (
    <div className="user-guide-overlay" onClick={onClose}>
      <div className="user-guide-popup" onClick={(e) => e.stopPropagation()}>
        <div className="user-guide-header">
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <span>Kullanasdım</span>
            <span>Kılavuzu</span>
          </div>
          <button className="close-button" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="user-guide-content">
          {pdfUrl ? (
            <iframe
              src={`${pdfUrl}#toolbar=0`}
              title="Kullanım Klavuzu"
              width="100%"
              height="100%"
              frameBorder="0"
              type="application/pdf"
            />
          ) : (
            <div className="no-pdf-message">
              <p>PDF dosyası yüklenmedi.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserGuidePopup;